/**
 * Converts weight from kilograms to pounds
 */
export function kgToLbs(kg: number): number {
  return kg * 2.20462
}

/**
 * Converts weight from pounds to kilograms
 */
export function lbsToKg(lbs: number): number {
  return lbs * 0.453592
}

/**
 * Converts height from centimeters to feet and inches
 * Returns an object with feet and inches properties
 */
export function cmToFtIn(cm: number): { feet: number; inches: number } {
  const totalInches = cm / 2.54
  const feet = Math.floor(totalInches / 12)
  const inches = Math.round(totalInches % 12)
  return { feet, inches }
}

/**
 * Converts height from feet and inches to centimeters
 */
export function ftInToCm(feet: number, inches: number): number {
  const totalCm = feet * 30.48 + inches * 2.54;
  return Math.round(totalCm); // Round the result to zero decimal places
}

